// extracted by mini-css-extract-plugin
module.exports = {"capability":"CapabilitiesList__capability","included":"CapabilitiesList__included","excluded":"CapabilitiesList__excluded"};